(function() {
  'use strict';

  angular
    .module('frontend', ['angularytics', 'ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ngResource', 'ui.router', 'ui.bootstrap', 'toastr']);

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController(seoSrv) {
    seoSrv.setTitle("The 1st photonics and technology transfer marketplace | PhotonTransfer");
    seoSrv.setMetadescription("PhotonTransfer is a trusted photonics and technology transfer market place for selling and buying patents and intellectual property worldwide.");
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('HowWorkController', HowWorkController);

  /** @ngInject */
  function HowWorkController(baseSrv, $scope, $timeout, $state, $stateParams, seoSrv) {
    var vm = this;
    vm.serviceUrl = baseSrv.getUrl();
    vm.action = vm.serviceUrl+'/register/';
    vm.current = $stateParams.section || 'R&D-center';
    vm.areCompanies = vm.current != 'R&D-center';
    if (vm.current == 'R&D-center') {
      seoSrv.setTitle("Sign up, list patents for sale and get leads of potential buyers");
      seoSrv.setMetadescription("Sign up as R&D center or researcher in PhotonTransfer, list your patents for sale or photonics tech and get qualified leads of potential buyers.");
      vm.formTitle = "Sign up in PhotonTransfer and";
      vm.title = "get qualified leads & potential buyers";
    } else {
      seoSrv.setTitle("Sign up and execute your intellectual property strategy");
      seoSrv.setMetadescription("Sign up as company and execute your intellectual property strategy to gain competitive advantage. We are experts in photonics technology transfer.");
      vm.formTitle = "Join the PhotonTransfer community and";
      vm.title = "gain competitive advantage";
    }
    vm.getForm = function(){
      baseSrv.getRegistrationForm().then(function(response){
        var data = response.data.replace(/<img[^>]*>/g,"");
        var form = angular.element(data);
        vm.token = form.find('#fos_user_registration_form__token').val();
      })
    }
    vm.switch = function() {
      if (vm.current == 'R&D-center') {
        return $state.go('howWork', {
          section: 'companies'
        });
      }
      $state.go('howWork', {
        section: 'R&D-center'
      });
    }
    vm.change = function(section){
      $state.go('howWork', {
        section: section
      });
    }
    $timeout(function(){
      seoSrv.ready();
    },100);
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('titleSeo', TitleSeo);

  /** @ngInject */
  function TitleSeo(seoSrv) {
    function link(scope, element) {
      element.text(seoSrv.getTitle());
      scope.$on('change-title',function(ev,title){
        element.text(title);
      })
    }
    return {
      link: link,
      restrict: 'A',
      scope: {
        titleSeo: '='
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('redirectTo', RedirectTo);

  /** @ngInject */
  function RedirectTo() {
    function link(scope, element, attrs) {
      element.attr('href','#');
      element.click(function(){
        scrollTo(0,0);
        location.replace(attrs.redirectTo);
      })
    }
    return {
      link: link,
      restrict: 'A'
    }
  }
})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('recentPublished', recentPublished);

  /** @ngInject */
  function recentPublished(baseSrv,seoSrv,$timeout) {
    function link(scope) {
      scope.advsGrp = false;
      baseSrv.getRecentAdvertisements().then(function(response){
        var advs = response.data.map(function(elem){
          var date = new Date(elem.date.date);
          elem.date = moment(date).format('L');
          elem.link = baseSrv.getUrl('/technology-transfer/'+elem.slug);
          elem.image = baseSrv.getUrl('/technology/img/'+elem.slug+'.jpeg');
          var tags = elem.tags.map(function(tag){
            tag.link = baseSrv.getUrl('/technology-source/'+tag.slug);
            return tag;
          });
          elem.tags = tags;
          return elem;
        });
        scope.advsGrp =  [advs.slice(0,3),advs.slice(3,6)];
        $timeout(function(){
          seoSrv.ready();
        },100);
      },function(){

      })
    }
    return {
      link: link,
      restrict: 'E',
      templateUrl: 'app/components/recentPublished/recentPublished.html'
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('lp1Menu', lp1Menu);

  /** @ngInject */
  function lp1Menu() {
    return {
      //link: link,
      restrict: 'E',
      templateUrl: 'app/components/menu/menu.html'
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('fullHight', FullHight);

  /** @ngInject */
  function FullHight($interval) {
    function link(scope, element) {
      var height = element.height(),
        doc = angular.element(document),
        win = angular.element(window),
        auxHeight, maxHeight;

      function update() {
        maxHeight = win.height();
        auxHeight = doc.height();
        height = element.height();
        if (height < maxHeight && height != auxHeight) {
          height = auxHeight;
          element.height(height);
        }else if(height > maxHeight && height != 'auto'){
          element.height('auto');
        }
      }
      update();
      var updater = $interval(update, 5);
      scope.$on('$destroy', function() {
        $interval.cancel(updater)
      });
    }
    return {
      link: link,
      restrict: 'A'
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('cookiesAlert', lp1Menu);

  /** @ngInject */
  function lp1Menu($cookies) {
    function link(scope, element) {
      scope.cookiesAlert = $cookies.get('cb-enabled') || false;
      if (scope.cookiesAlert)
        element.hide();
      scope.cookiesAccepted = function() {
        element.hide();
        $cookies.put('cb-enabled', 'accepted', {
          path: '/'
        });
      }
    }
    return {
      link: link,
      restrict: 'E',
      templateUrl: 'app/components/cookiesAlert/cookiesAlert.html'
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .directive('cloneHeight', CloneHeight);

  /** @ngInject */
  function CloneHeight($log, $interval) {
    function link(scope, element, attrs) {
      var height = element.height(),
        ref = angular.element(attrs.cloneHeight),
        //doc = angular.element(document),
        maxHeight; //auxWidth;

      function update() {
        maxHeight = ref.height();
        height = element.height();
        //auxWidth = doc.width();
        if (height != maxHeight) {
          element.height(maxHeight);
        }/* else if (auxWidth <= 767 && element.css('height') != 'auto') {
          $log.log('CloneHeight',auxWidth,element.css('height'));
        }*/
      }
      update();
      var updater = $interval(update, 5);
      scope.$on('$destroy', function() {
        $interval.cancel(updater)
      });
    }
    return {
      link: link,
      restrict: 'A'
    }
  }
})();

/*global document*/
(function() {
  'use strict';

  angular
    .module('frontend')
    .factory('seoSrv', function($rootScope, $window) {
      var title = "The 1st photonics and technology transfer marketplace | PhotonTransfer",
        metadescription = "PhotonTransfer is a trusted photonics and technology transfer market place for selling and buying patents and intellectual property worldwide.";

      function setTitle(_title) {
        title = _title;
        document.title = title;
        $rootScope.$broadcast('change-title', title);
      }

      function getTitle() {
        return title;
      }

      function setMetadescription(_metadescription) {
        metadescription = _metadescription;
        $rootScope.$broadcast('change-metadescription', metadescription);
      }

      function getMetadescription() {
        return metadescription;
      }

      function ready() {
        if (typeof $window.callPhantom == 'function') {
          $window.callPhantom();
        }
      }

      return {
        'ready': ready,
        'getTitle': getTitle,
        'setTitle': setTitle,
        'getMetadescription': getMetadescription,
        'setMetadescription': setMetadescription
      };
    });
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .factory('baseSrv', function(serviceUrl, $http) {
      function query(method,route,params){
        return $http({
          method: method,
          params: params,
          url: serviceUrl + route
        });
      }

      function getRecentAdvertisements() {
        return query('GET','/services/technology/recently');
      }

      function getUrl(url) {
        return serviceUrl + (url || '');
      }

      function getRegistrationForm(){
        return query('GET','/register/');
      }

      return {
        'getRecentAdvertisements': getRecentAdvertisements,
        'getRegistrationForm': getRegistrationForm,
        'getUrl': getUrl
      };
    });
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .controller('HeadController', HeadController);

  /** @ngInject */
  function HeadController($scope, seoSrv) {
    var vm = this;
    vm.title = seoSrv.getTitle();
    $scope.$on('change-title',function(ev,title){
      vm.title = title;
    })
    vm.metadescription = seoSrv.getMetadescription();
    $scope.$on('change-metadescription',function(ev,metadescription){
      vm.metadescription = metadescription;
    })
  }
})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log,Angularytics) {
    Angularytics.init();
    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/pages/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('howWorkBase', {
        url: '/sign-up',
        templateUrl: 'app/pages/howWork/howWork.html',
        controller: 'HowWorkController',
        controllerAs: 'howWork'
      })
      .state('howWork', {
        url: '/sign-up/:section',
        templateUrl: 'app/pages/howWork/howWork.html',
        controller: 'HowWorkController',
        controllerAs: 'howWork'
      });

    $urlRouterProvider.otherwise(function() {
      location.reload();
    });
  }

})();

(function() {
  'use strict';
  var serviceUrl = (location.port == "3000")?'//pt.com':'';
  angular
    .module('frontend')
    .constant('serviceUrl',serviceUrl);

})();

(function() {
  'use strict';

  angular
    .module('frontend')
    .config(config);

  /** @ngInject */
  function config($logProvider,$locationProvider,AngularyticsProvider) {
    // Enable log
    $logProvider.debugEnabled(true);
    $locationProvider.html5Mode(true).hashPrefix('!');
    AngularyticsProvider.setEventHandlers(['Console', 'GoogleUniversal']);
  }

})();

angular.module("frontend").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/cookiesAlert/cookiesAlert.html","<div class=\"cookiesAlert\">This website uses cookies to allow us to see how the site is used. The cookies cannot identify you. If you continue to use this site we will assume that you are happy with this.<div class=\"actions\"><button ng-click=\"cookiesAccepted()\" class=\"btn btn-primary\">I Understand</button> <a target=\"_blank\" class=\"btn btn-default\" href=\"/privacy-policy/\">Privacy policy</a></div></div>");
$templateCache.put("app/components/menu/menu.html","<div id=\"menu\"><div><div><a redirect-to=\"/technology-transfer/\"><span>Tech for transfer</span></a> <a redirect-to=\"/to-buy-or-tech-need/\"><span>Tech need</span></a></div><div><a redirect-to=\"/xphotonchallenge/\"><span>XPhoton Open Innovation Challenge</span></a> <a redirect-to=\"/technology/challenge\"><span>View Challenges</span></a></div><div><a redirect-to=\"http://photontransfer.com/blog/\"><span>Blog</span></a> <a redirect-to=\"/news/\"><span>Industry & photonics news</span></a></div><div><a redirect-to=\"http://photontransfer.com/blog/about/\"><span>About us</span></a> <a redirect-to=\"/contact/\"><span>Contact us</span></a> <a redirect-to=\"/terms-of-use/\"><span>Terms of use</span></a> <a redirect-to=\"/privacy-policy/\"><span>Privacy policy</span></a></div></div></div>");
$templateCache.put("app/components/recentPublished/recentPublished.html","<div id=\"recentPublished\"><h1>RECENT PUBLISHED LISTINGS</h1><div class=\"loading\" ng-show=\"advsGrp == false\"><i class=\"fa fa-circle-o-notch fa-spin\"></i></div><div ng-show=\"advsGrp != false\"><div class=\"row content\" ng-repeat=\"advs in advsGrp\"><div ng-repeat=\"adv in advs\"><div class=\"panel panel-default\"><div class=\"panel-body adv\"><img ng-src=\"{{adv.image}}\" alt=\"\" class=\"img-thumbnail\"> <a class=\"title\" ng-href=\"{{adv.link}}\"><span>{{adv.title}}</span></a> <span class=\"type\" ng-if=\"adv.type != \'tech_need\'\"><i class=\"fa fa-check-circle-o\"></i> Tech for Transfer</span> <span ng-if=\"adv.private\" class=\"private\">Hidden author</span> <span ng-if=\"!adv.private\" class=\"private\">{{adv.user.username}}</span> <span class=\"date\">{{adv.date}}</span><p>{{adv.description | limitTo:100}}...</p><div class=\"tags\"><a ng-repeat=\"tag in adv.tags\" ng-href=\"{{tag.link}}\">{{tag.name}}</a></div><a ng-href=\"{{adv.link}}\" class=\"btn btn-default pull-right\"><i class=\"fa fa-plus\"></i> Tell me more</a></div></div></div></div><div class=\"text-center\"><a class=\"btn btn-primary btn-lg\" href=\"/technology-transfer/\">VIEW LISTINGS</a></div></div></div>");
$templateCache.put("app/pages/howWork/howWork.html","<div id=\"howWork\"><div class=\"rowinside\"><div class=\"col-xs-12 col-md-8 fgfg\"><div class=\"center-blockcn\"><div class=\"title_container\"><div><img src=\"assets/images/icon_left.png\"></div><div class=\"title\"><h3>Bridging the gap between science and industry</h3></div><div><img src=\"assets/images/icon_right.png\"></div></div><div class=\"row tabs\"><div class=\"col-xs-6\"><img src=\"assets/images/research.png\" alt=\"\"><br><button ng-click=\"howWork.change(\'R&D-center\')\" ng-class=\"{active: !howWork.areCompanies}\" type=\"button\" name=\"r&d\">R&D Centers</button></div><div class=\"col-xs-6\"><img src=\"assets/images/companies.png\" alt=\"\"><br><button ng-click=\"howWork.change(\'companies\')\" ng-class=\"{active: howWork.areCompanies}\" type=\"button\" name=\"companies\">Companies</button></div></div><img src=\"assets/images/top_shadow.png\"><h1>{{howWork.title}}</h1><img src=\"assets/images/bottome-shaddow.png\"></div><div ng-class=\"{left_tp: true, active: !howWork.areCompanies}\"><div class=\"padnone\"><div class=\"circl_left circulo_rd\"><div class=\"col-xs-8\"><ul class=\"cirle_left\"><img class=\"nopd\" src=\"assets/images/bullet_link.png\"><li>Offer your Licenses & Patents</li><img class=\"nopd\" src=\"assets/images/bullet_link.png\"><li>Find Buyers for your R&D resources</li></ul></div><div class=\"col-xs-4\"><img src=\"assets/images/photon_icon.png\"></div></div></div></div><div class=\"overlay\" ng-click=\"howWork.switch()\"></div><div ng-class=\"{left_rgt: true, active: howWork.areCompanies}\"><div class=\"\"><div class=\"circl_left circlrgt circulo_co\"><div class=\"col-xs-4\"><img src=\"assets/images/photon_icon.png\"></div><div class=\"col-xs-8\"><ul class=\"cirle_left\"><img class=\"nopd\" src=\"assets/images/bullet_link.png\"><li>Acquire Patents & Licenses</li><img class=\"nopd\" src=\"assets/images/bullet_link.png\"><li>Search & Find extra R&D Capacity</li></ul></div></div></div></div><div class=\"lists\"><div class=\"benfits\"><span>BENEFITS</span></div><div class=\"benefits_list\" ng-if=\"!howWork.areCompanies\"><ul><li>Intellectual Property Licensing</li><li>Intellectual Property Selling</li><li>Access to industrial buyers & partners</li></ul><ul><li>Become a Solver and win Innovation Challenges</li><li>Get funding and economic rewards</li><li>Joint Research</li></ul><ul><li>R&D Resources Optimization</li><li>Take your R&D results to the market</li><li><a target=\"_blank\" href=\"//photontransfer.com/benefits-for/institutions/\">More</a></li></ul></div><div class=\"benefits_list\" ng-if=\"howWork.areCompanies\"><ul><li>Reduce fixed R&D costs</li><li>Get Partners for joint R&D</li><li>Reduce time-to-market</li></ul><ul><li>Do competitive and success fee R&D</li><li>Technology Watch</li><li>Researchers and Solvers available for your projects</li></ul><ul><li>Avoid litigation by cross – licensing</li><li><a target=\"_blank\" href=\"//photontransfer.com/benefits-for/companies/\">More</a></li></ul></div></div><a ui-sref=\"home\" class=\"go-home\"><i class=\"fa fa-chevron-left\"></i> go back</a></div><div class=\"col-md-4 col-xs-12 right_pad\" clone-height=\".fgfg\"><div class=\"rightfrm\"><form role=\"form\" action=\"/register/\" method=\"POST\" ng-init=\"howWork.getForm()\"><h2>{{howWork.formTitle}}<br>{{howWork.title}}</h2><div class=\"form-group\"><label for=\"email\">Username:</label> <input name=\"fos_user_registration_form[username]\" type=\"text\" class=\"form-control\" id=\"name\"></div><div class=\"form-group\"><label for=\"email\">Email address:</label> <input name=\"fos_user_registration_form[email]\" type=\"email\" class=\"form-control\" id=\"email\"></div><div class=\"form-group\"><label for=\"pwd\">Password:</label> <input name=\"fos_user_registration_form[plainPassword][first]\" type=\"password\" class=\"form-control\" id=\"pwd\"></div><div class=\"form-group\"><label for=\"pwd\">Repeat Password:</label> <input name=\"fos_user_registration_form[plainPassword][second]\" type=\"password\" class=\"form-control\" id=\"pwd\"></div><div class=\"form-group\"><label for=\"pwd\">First Name:</label> <input name=\"fos_user_registration_form[firstname]\" type=\"text\" class=\"form-control\" id=\"pwd\"></div><div class=\"form-group\"><label for=\"pwd\">Last Name:</label> <input name=\"fos_user_registration_form[lastname]\" type=\"text\" class=\"form-control\" id=\"pwd\"></div><div class=\"form-group\"><label for=\"pwd\">Institution:</label> <input name=\"fos_user_registration_form[institutionName]\" type=\"text\" class=\"form-control\" id=\"pwd\"></div><div class=\"form-group\"><label class=\"required\">I\'m working at</label><div id=\"fos_user_registration_form_userType\"><input type=\"radio\" id=\"fos_user_registration_form_userType_0\" name=\"fos_user_registration_form[userType]\" required=\"required\" value=\"institution\"> <label for=\"fos_user_registration_form_userType_0\" class=\"required\">Institution</label> <input type=\"radio\" id=\"fos_user_registration_form_userType_1\" name=\"fos_user_registration_form[userType]\" required=\"required\" value=\"company\"> <label for=\"fos_user_registration_form_userType_1\" class=\"required\">Company</label> <input type=\"radio\" id=\"fos_user_registration_form_userType_2\" name=\"fos_user_registration_form[userType]\" required=\"required\" value=\"business\"> <label for=\"fos_user_registration_form_userType_2\" class=\"required\">Business</label></div></div><div class=\"form-group terms\"><input type=\"checkbox\" id=\"fos_user_registration_form_check\" name=\"fos_user_registration_form[check]\" required=\"required\" value=\"1\"> I have read and accept the <a href=\"/privacy-policy/\" target=\"_blank\">Privacy policy</a> and the <a href=\"/terms-of-use/\" target=\"_blank\">Terms of use</a></div><input type=\"hidden\" id=\"fos_user_registration_form__token\" name=\"fos_user_registration_form[_token]\" ng-value=\"howWork.token\"><div class=\"btnctnr\"><button type=\"submit\" class=\"btn btn-lg btn-success btn-block\">Register Now</button></div></form></div></div></div></div>");
$templateCache.put("app/pages/main/main.html","<div id=\"main\"><div id=\"wrapper\"><section id=\"section\" class=\"benner\"><header id=\"header\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div class=\"header_right pull-right\"><div class=\"same login\"><a href=\"/login\">Login</a></div><div class=\"same register\"><a href=\"/join-us\">Register</a></div></div></div></div></div></header><div class=\"threemain_part\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div class=\"contain_part\"><div class=\"col-md-4 col-sm-4 col-xs-12 leftpart\"><a class=\"top_part\" ui-sref=\"howWork({section:\'R&D-center\'})\"><img src=\"assets/images/research.png\" width=\"222\" height=\"214\" alt=\"image\"></a><div class=\"bottom_part\"><h2>For Research & Development Centers</h2><p>Accelerate Technology Transfer & Take Your Research Result To The Market</p></div><span></span></div><div class=\"col-md-4 col-sm-4 col-xs-12 midpart\"><div class=\"top_part\"><img src=\"assets/images/photontransfer.png\" width=\"240\" height=\"239\" alt=\"image\"></div><div class=\"bottom_part\"><a ui-sref=\"howWorkBase\">Find out how it works</a></div></div><div class=\"col-md-4 col-sm-4 col-xs-12 rightpart\"><a class=\"top_part\" ui-sref=\"howWork({section:\'companies\'})\"><img src=\"assets/images/companies.png\" width=\"222\" height=\"214\" alt=\"image\"></a><div class=\"bottom_part\"><h2>For<br>Companies</h2><p>Enhance Your Research & Development Capacity For Free: Do Success Fee R & D</p></div><span></span></div></div></div></div></div></div></section><div class=\"phtontransfer\"><div class=\"left-part\"></div><div class=\"right-part\"></div><div class=\"container\"><div class=\"row\"><div class=\"col-md-6 col-sm-6 col-xs-12 xphoton phtransfer\"><img src=\"assets/images/leftlogo.png\" width=\"214\" height=\"50\" alt=\"image\"><h2>Tech For Transfer</h2><p>Light-based patents and know-how ready to be licensed.</p><div class=\"btn\"><a href=\"/technology-transfer/\">Get Started</a></div></div><div class=\"col-md-6 col-sm-6 col-xs-12 xphoton\"><img src=\"assets/images/rightlogo.png\" width=\"208\" height=\"50\" alt=\"image\"><h2>Open Innovation Challenge</h2><p>Publish your Request for technological Proposals and get solutions from worldwide photonics experts.</p><div class=\"btn\"><a href=\"/xphotonchallenge\">Request For Proposals</a></div></div></div><span></span></div></div><div class=\"search_tech\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 col-xs-12 technology\"><div class=\"col-md-3 col-sm-3 col-xs-12 title\"><h3>SEARCH PATENTS & TECH:</h3></div><div class=\"col-md-6 col-sm-6 col-xs-12 text-center sea_in\"><form class=\"search_input\" action=\"/technology/list\" method=\"get\"><input type=\"text\" name=\"search\" id=\"name\" placeholder=\"Title, Topic, Author, Description\"> <button type=\"submit\"></button></form></div><div class=\"col-md-3 col-sm-3 col-xs-12 teclist\"><div class=\"btn\"><a href=\"/technology-transfer/\">technology listings</a></div></div></div></div></div></div><recent-published></recent-published><div class=\"logo_Part\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div class=\"col-md-3 col-sm-3 col-xs-12 photonn\"><img src=\"assets/images/rightlogo.png\" width=\"208\" height=\"50\" alt=\"image\"></div><div class=\"col-md-3 col-sm-3 col-xs-12 photonn\"><img src=\"assets/images/epiclogo.png\" width=\"153\" height=\"54\" alt=\"image\"></div><div class=\"col-md-3 col-sm-3 col-xs-12 photonn\"><img src=\"assets/images/international.png\" width=\"124\" height=\"59\" alt=\"image\"></div><div class=\"col-md-3 col-sm-3 col-xs-12\"><img src=\"assets/images/leftlogo.png\" width=\"214\" height=\"48\" alt=\"image\"></div></div></div></div></div><lp1-menu></lp1-menu><footer id=\"footer\"><div class=\"container\"><div class=\"row\"><div class=\"col-md-12 col-xs-12 footer_main\"><p>© 2015 <a href=\"/\">Photon Transfer.</a> All Rights Reserved</p></div></div></div></footer></div></div>");}]);